import * as R from 'ramda';
import { parseISO, isBefore } from 'date-fns/fp';

export const getDoctorId = R.pathOr(null, ['user', 0, 'doctor', 'id']);
export const isEventEnrolled = R.pipe(R.propOr([], 'doctors'), R.isEmpty, R.not);
export const isEventExpired = R.pipe(R.propOr('', 'date'), parseISO, isBefore(new Date()));
export const getEnrollButtonText = R.cond([
  [isEventEnrolled, R.always('Enrolled')],
  [isEventExpired, R.always('Not Available')],
  [R.T, R.always('Enroll')],
]);
export const isSkipEventsQuery = ({ id, HKDUUserInfo }) => !id || !getDoctorId(HKDUUserInfo);
